/* eslint-disable object-shorthand */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/href-no-hash */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { Button, Table, Icon } from 'semantic-ui-react';
// import Carousel from 'react-image-carousel';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import _ from 'lodash';

import './PreviewList.css';

class PreviewList extends Component {
  state = {
    showConfirm: false,
    canvasToDelete: '',
    canvasIndex: ''
  };

  renderImage = (canvas) => {
    if (canvas.type === 'Photo') {
      return canvas.url ? (
        <img className="img-canvas" src={canvas.url} alt="" />
      ) : (
        ''
      );
    } else if (canvas.type === 'Carousel') {
      const imageUrls = canvas.cards.map((card) => {
        return card.cardImageUrl;
      });
      return (
        <div className="my-carousel">
          <Carousel>
            {imageUrls.map((url) => {
              return (
                <div>
                  <img src={url} alt="" />
                </div>
              );
            })}
          </Carousel>
        </div>
      );
    } else if (canvas.type === 'Video') {
      return (
        <video key={canvas.url} width="100%" controls loop autoPlay>
          <track kind="captions" />
          <source src={canvas.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
    return '';
  };

  openDialog = (e, { data }) => {
    this.setState({
      showConfirm: true,
      canvasToDelete: data.canvas,
      canvasIndex: data.canvasIndex
    });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false, canvasToDelete: '', canvasIndex: '' });
  };

  handleConfirm = () => {
    this.props.deleteCanvasElement(
      this.state.canvasToDelete,
      this.state.canvasIndex
    );
    this.setState({ showConfirm: false, canvasToDelete: '', canvasIndex: '' });
  };

  swapCanvasElement = (position, direction) => {
    this.props.swapCanvasElement(position, direction);
  };

  render() {
    if (this.props.canvasElements) {
      const canvasElements = _.sortBy([...this.props.canvasElements], 'order');
      console.log('canvas elements', canvasElements);
      return (
        <div className="preview-list">
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="row-img">Asset</Table.HeaderCell>
                {!this.props.showOnlyAssets ? (
                  <Table.HeaderCell className="row-name">Name</Table.HeaderCell>
                ) : null}
                {!this.props.showOnlyAssets ? (
                  <Table.HeaderCell className="row-type">Type</Table.HeaderCell>
                ) : null}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {canvasElements.map((canvas, index) => (
                <Table.Row key={canvas.url}>
                  <Table.Cell className="col-img">
                    {this.renderImage(canvas)}
                  </Table.Cell>
                  {!this.props.showOnlyAssets ? (
                    <Table.Cell>
                      {canvas.id ? (
                        <a
                          id={canvas.id}
                          type={canvas.type}
                          onClick={this.props.editCanvasElement}
                          href="#"
                        >
                          {canvas.name}
                        </a>
                      ) : (
                        canvas.name
                      )}
                    </Table.Cell>
                  ) : null}
                  {!this.props.showOnlyAssets ? (
                    <Table.Cell className="type-container">
                      {!this.state.showConfirm ||
                      index !== this.state.canvasIndex ? (
                        <div className="col-type">
                          {canvas.type}
                          <div>
                            <Button
                              onClick={this.props.editCanvasElement}
                              size="big"
                              color="grey"
                              className="edit-button"
                            >
                              <Icon
                                name="edit"
                                id={`${canvas.id}-${canvas.type}`}
                              />
                            </Button>
                            <Button
                              data={{ canvas, canvasIndex: index }}
                              onClick={this.openDialog}
                              size="big"
                              color="grey"
                              className="remove-button"
                            >
                              <i className="info trash icon trash-format" />
                            </Button>
                          </div>
                          <div>
                            {index !== 0 ? (
                              <a
                                className="arrow-icon"
                                onClick={() =>
                                  this.swapCanvasElement(index, 'up')
                                }
                              >
                                <Icon
                                  size="large"
                                  name="arrow alternate circle up"
                                />
                              </a>
                            ) : null}
                            {index !== canvasElements.length - 1 ? (
                              <a
                                className="arrow-icon"
                                onClick={() =>
                                  this.swapCanvasElement(index, 'down')
                                }
                              >
                                <Icon
                                  size="large"
                                  name="arrow alternate circle down"
                                />
                              </a>
                            ) : null}
                          </div>
                        </div>
                      ) : null}
                      <div className="delete-canvas-link">
                        {this.state.showConfirm &&
                        index === this.state.canvasIndex ? (
                          <div className="div-confirm">
                            <p className="text-confirm">Are you sure?</p>
                            <Button
                              onClick={this.handleConfirm}
                              size="mini"
                              color="grey"
                              className="confirm-buttons"
                            >
                              Yes
                            </Button>
                            <Button
                              onClick={this.handleCancel}
                              size="mini"
                              color="red"
                              className="confirm-buttons"
                            >
                              No
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    </Table.Cell>
                  ) : null}
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default PreviewList;



// WEBPACK FOOTER //
// ./src/screens/Canvas/PreviewList.js